export const excludePrivateSpaceSites = ({ sites, spaces }) => {
  const privateSpaceIds = new Set(spaces.filter((space) => space.isPrivate).map((space) => String(space.spaceId)))
  return privateSpaceIds.size ? sites.filter((site) => !privateSpaceIds.has(String(site.spaceId))) : sites
}
